/*
 * @Description : auto-login.plugin.ts
 * @Author      : pishengjun
 * @Date        : 2025-05-30 10:17:06
 */
import type { Store } from "vuex";
import type { IRootStore } from "@/store/interface";

export default (store: Store<IRootStore>) => {
  // 初始化时同步登录状态
  const currentUser = store.state.currentRegisterUser;
  const isLogin = !!currentUser && !isEmptyObject(currentUser);
  store.commit("SET_DATA", { name: "isLogin", data: isLogin });

  // 监听 SET_DATA 突变
  store.subscribe((mutation, state) => {
    if (mutation.type === "SET_DATA" && mutation.payload.name === "currentRegisterUser") {
      store.commit("SET_DATA", { name: "isLogin", data: !!state.currentRegisterUser && !isEmptyObject(state.currentRegisterUser) });
    }
  });
};


function isEmptyObject(obj: any): boolean {
  return obj && typeof obj === 'object' && Object.keys(obj).length === 0;
}